module.exports = __webpack_public_path__ + "img/add_to_map.f50a9391.svg";